import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class FlyoutService {
	public open$ = new Subject<boolean>();
	public flyout$ = new BehaviorSubject<any>(undefined);

	open(portal: any) {
		this.setPortal(portal);
		this.open$.next(true);
	}

	toggle(portal?: any) {
		if (this.flyout$.value) {
			this.close();
		} else {
			this.open(portal);
		}
	}

	close() {
		this.open$.next(false);
		this.flyout$.next(null);
	}

	setPortal(portal: any) {
		this.flyout$.next(portal);
	}
}
